import {
    AutogenLayoutMacropointTrackingVendorOptionsPanel
} from "./autogen/AutogenLayoutMacropointTrackingVendorOptionsPanel";
import {ChangeEvent, ClickEvent, DataDisplayEvent, Switch, TableRowCreationEvent, Textbox} from "@mcleod/components";
import {ModelRow, StringUtil} from "@mcleod/core";
import {CommonDialogs} from "@mcleod/common";

export class MacropointTrackingVendorOptionsPanel extends AutogenLayoutMacropointTrackingVendorOptionsPanel {

    private macropointRequestorId = "";
    private shownNotification = false;

    tableDocumentTypeOnRowCreate(event: TableRowCreationEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        modelRow.set("vendor_id", "M");

    }

    switchIndexToImagingOnChange(event: ChangeEvent): void {
        this.textboxImagingDropPath.visible = event.newValue === true;
        this.textboxImagingDropPath.required = event.newValue === true;
        this.tableDocumentType.visible = event.newValue === true;
    }

    switchEnableGlobalNotificationsOnChange(event: ChangeEvent){
        const switchEnabledGlobalNotifications = event.target as Switch;
        this.textboxMacropointRequestorId.visible = switchEnabledGlobalNotifications.checked;
        this.textboxLoadId.visible = switchEnabledGlobalNotifications.checked;
        this.textboxMacropointRequestorId.required = switchEnabledGlobalNotifications.checked;
        this.textboxLoadId.required = switchEnabledGlobalNotifications.checked;

        if(!switchEnabledGlobalNotifications.checked && !this.shownNotification){
            this.showNotificationMessage();
            this.shownNotification = true;
        }
    }

    textboxMacropointRequestorIdOnChange(event: ChangeEvent){
        if(event.userInitiatedChange){
            if(!this.shownNotification && !StringUtil.isEmptyString(this.macropointRequestorId)){
                this.showNotificationMessage();
                this.shownNotification = true;
            }
        }else{
            this.macropointRequestorId = this.textboxMacropointRequestorId.text;
        }
    }

    textboxLoadIdOnChange(event: ChangeEvent){
        if(!StringUtil.isEmptyString(event.oldValue) && !this.shownNotification){
            this.showNotificationMessage();
            this.shownNotification = true;
        }
    }

    textboxStartTimePreferenceOnDataDisplay(event: DataDisplayEvent){
        if(!StringUtil.equalsIgnoreCase("M",event.rowData?.get("vendor"))){
            this.textboxStartTimePreference.visible = false;
            this.textboxStartTimeOffset.visible = false;
            return;
        }
        this.textboxStartTimePreference.visible = true;
        this.textboxStartTimeOffset.visible = !StringUtil.isEmptyString(event.rowData?.get("start_time_preference")) &&
            !StringUtil.equalsIgnoreCase("N", event.rowData?.get("start_time_preference"));
    }

    textboxStartTimePreferenceOnChange(event: ChangeEvent): void{
        this.textboxStartTimeOffset.visible = !StringUtil.isEmptyString(event.newValue) &&
            !StringUtil.equalsIgnoreCase("Current Time", event.newValue);

    }

    showNotificationMessage(){
        CommonDialogs.showMessage("Changes to the global notification settings will not be made for loads actively tracking unless the tracking is canceled and restarted.", "Notification");

    }
    private getVendorId() {
        if (this.macropointVendorOptionsPanel.visible) {
            return "M";
        }
    }

    private getDefaultVendorList(default_vendor_list: any): string {
        let result = "\n\n";
        for (let i = 0; i < default_vendor_list.length; i++) {
            result += default_vendor_list[i].vendor + "\n";
        }
        return result;
    }
}
